import React, { useEffect, useState } from "react";
import { fetchAuthedBlob } from "./api";

type Props = {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  className?: string;
  fallback?: React.ReactNode;
};

export function AuthedImage({ src, alt, style, className, fallback }: Props) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let canceled = false;
    let nextUrl: string | null = null;
    setObjectUrl(null);

    const load = async () => {
      try {
        const blob = await fetchAuthedBlob(src);
        nextUrl = URL.createObjectURL(blob);
        if (!canceled) setObjectUrl(nextUrl);
      } catch {
        if (!canceled) setObjectUrl(null);
        if (nextUrl) URL.revokeObjectURL(nextUrl);
      }
    };

    if (src) load();
    return () => {
      canceled = true;
      if (nextUrl) URL.revokeObjectURL(nextUrl);
    };
  }, [src]);

  if (!objectUrl) return <>{fallback ?? null}</>;
  return <img src={objectUrl} alt={alt} style={style} className={className} />;
}

